
const config = {
  SEARCH_CONVERSION: 'searchResultConversion',
  SEARCH_TOKEN_URL: '/search/searchToken',
  CONTENT_HELPFULNESS_VOTE_URL: '/helpfulness/vote',
  CONTENT_HELPFULNESS_SETTINGS_URL: '/helpfulness/widgetSettings',
  topicTypes: {
    QUESTION: 'questions',
    ANSWERED: 'answers',
    DISCUSSION: 'discussions',
    ARTICLE: 'articles'
  },
  ratingDataMap: {
    ga: {
      topichelpful: 'Topic upvote',
      topicneutral: 'Topic neutral',
      topicnothelpful: 'Topic downvote'
    },
    messagebus: {
      topichelpful: 'helpful',
      topicneutral: 'neutral',
      topicnothelpful: 'not helpful'
    }
  }
}

module.exports = config
